import { useState } from "react";
import { api } from "../../../../../../../../utility/api";

export const BoletaTrasladoApi = () => {
    const [cargando, setCargando] = useState(false);

    const getTraslado = async (id) => {
        try {
            setCargando(true);
            const response = await api.get(`prod_bodega_control_calidad/${id}`);
            return response;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            setCargando(false);
        }
    };

    return {
        getTraslado,

        cargando,
    };
};
